import { useState, useEffect } from 'react'

type Props = {
  value: string
  delay?: number
}

// todo: replace with packages/common_packages/assets/js/hooks/useDebouncedState.ts
const useDebounce = ({ value, delay = 200 }: Props) => {
  const [debouncedValue, setDebouncedValue] = useState(value)
  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value)
      }, delay)

      return () => {
        clearTimeout(handler)
      }
    },
    [value, delay],
  )

  return debouncedValue
}

export default useDebounce
